import * as SeatMap from './SeatMap/SeatMap.css';
import * as PassengersList from './PassengersList/PassengersList.css';
import * as SelectPassenger from './SelectPassenger/SelectPassenger.css';
import * as Controls from './Controls/Controls.css';
import * as PassengerOptions from './PassengerOptions/PassengerOptions.css';
import * as SeatsLegend from './SeatsLegend/SeatsLegend.css';

export default {
	SeatMap,
	PassengersList,
	SelectPassenger,
	Controls,
	PassengerOptions,
	SeatsLegend
};
